import {Grid, Typography} from '@yandex-delivery/blocks'
import {tag2url} from '@yandex-delivery/utils'
import React from 'react'

import {logoClasses} from './FooterLogo@desktop.classes'

export type FooterLogoProps = {
  phrase1: string | JSX.Element
  phrase2?: string | JSX.Element
  invert?: boolean
}

export function FooterLogoDesktop({phrase1, phrase2, invert}: FooterLogoProps) {
  return (
    <Grid direction="column" container>
      <Grid className={logoClasses.gap} direction={invert ? 'column-reverse' : 'column'} container>
        <Typography className={logoClasses.phrase} color="invert" thickness="regular" variant="title1">
          {phrase1}
        </Typography>
        <Grid alignItems="center" className={logoClasses.logoContainer} container item>
          <img alt="arrow" src={tag2url('delivery_footer_arrow')} className={logoClasses.arrow} />
          <img alt="logo" src={tag2url('delivery_go_logo')} className={logoClasses.logo} />
        </Grid>
      </Grid>
      {phrase2 && (
        <Grid item>
          <Typography className={logoClasses.qrPhrase} thickness="regular" variant="body1">
            {phrase2}
          </Typography>
        </Grid>
      )}
    </Grid>
  )
}
